import { useEffect, useState } from 'react';
import './google.css'
import Config from 'config/config';
import Tools from 'libs/utils/Tools';

export default function GoogleLogin(props: {className: string}){

    const [ googleBtnWidth, setGoogleBtnWidth ] = useState<number>(400);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client'; 
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        const clientWidth = document.body.clientWidth ;
        if(clientWidth < 440){
            setGoogleBtnWidth(clientWidth - 40)
        }

        // @ts-expect-error: google
        window.handleCredentialResponse = (googleUser : unknown) => {
            // @ts-expect-error: google
            location.href = Tools.disponseUrl(Config.apiDomain + '/biz/auth/google/login?credential=' + googleUser.credential +  '&callback=' + encodeURIComponent(Config.platformUrl)) ;
        }
        
        return () => {
            document.body.removeChild(script);
        };
    },[])

    return (
        <>
            <div className={props.className}>
                <div id="g_id_onload"
                    data-client_id={Config.googleClientId}
                    data-callback="handleCredentialResponse">
                </div>
                <div className={"g_id_signin g__1"} data-text="signin_with" data-logo_alignment="center" data-width={googleBtnWidth}></div>
            </div>
        </>
    )
}